export default "__VITE_ASSET__9ec3559a__"